import * as React from 'react';
import { useHistory } from "react-router-dom";
import themePrimary from '../../styles/themePrimary';
import { Typography, makeStyles, useMediaQuery, Accordion, AccordionDetails, AccordionSummary, IconButton, AccordionProps, styled, AccordionSummaryProps } from '@material-ui/core';
import MiniButton, { MiniButtonProps } from '../common/Buttons/MiniButton';
import ViewCheckDialog, { ViewCheckDialogProps } from '../common/ViewCheckDialog';
import { String_MultipleChecks_CheckNumberLabel, String_MultipleChecks_CheckTotalLabel, String_MultipleChecks_Instruction,
     String_System_Pay, String_System_View, String_System_GeneralError, String_System_ConnectionError } from '../../utilities/StringHelper';
import { ElementDimensions } from '../../styles/ElementDimensions';
import { CheckSummary } from '../../models/common/CheckSummary';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import SignalR, { CheckMessageType, CheckNotificationType, OnNotificationReceivedHandler } from '../common/SignalR';
import { CheckFlat } from '../../models/common/CheckFlat';
import CheckDetails from '../common/CheckDetails';
import axios, { CancelTokenSource } from 'axios';
import { GetCheckRequest } from '../../models/checkout/GetCheckRequest';
import { GetCheckResponse } from '../../models/checkout/GetCheckResponse';
import ErrorDialog, { ErrorDialogProps } from '../common/ErrorDialog';
import { ErrorCode } from '../../models/common/ErrorCode';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { POSType } from '../../models/common/POSType';

const useStyles = makeStyles({
    checkContainer: {
        borderRadius: '6px',
        backgroundColor: themePrimary.palette.grey[200],
        margin: ElementDimensions.margin10 + 'px',
    },
    checkNumberLabel: {
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    details: {
        position: 'absolute',
        top: (ElementDimensions.appBarHeight) + 'px',
        bottom: '0px',
        left: 0,
        right: 0,
        width: '100%',
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    detailsLandscape: {
        position: 'absolute',
        top: '0px',
        bottom: '0px',
        left: 'calc(100vw *.3)',
        width: 'calc(100vw *.7)',
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    expanderButton: {
        fontSize: '1.75em !important',
    },
    footerButtons: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        height: ElementDimensions.footerBarHeight + 'px',
        padding: ElementDimensions.padding10 + 'px ' + '0px ' + ElementDimensions.padding10 + 'px 0px',
        width: '100%',
        borderTop: '2px solid ' + themePrimary.palette.grey[200],
        backgroundColor: themePrimary.palette.primary.contrastText,
    },
    footerButtonsLandscape: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        left: 'calc(100vw *.3)',
        height: ElementDimensions.footerBarHeightLandscape + 'px',
        padding: ElementDimensions.padding10 + 'px ' + '0px ' + ElementDimensions.padding10 + 'px 0px',
        width: 'calc(100vw * .7)',
        borderTop: '2px solid ' + themePrimary.palette.grey[200],
        backgroundColor: themePrimary.palette.primary.contrastText,
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'auto auto',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: ElementDimensions.margin10 + 'px',
        marginBottom: ElementDimensions.margin10 + 'px',
    },
    headerContainer: {
        backgroundColor: themePrimary.palette.grey[200],
        padding: ElementDimensions.padding10 + 'px ',
        borderRadius: '6px',
        display: 'flex',
    },
    headerGrid: {
        display: 'grid',
        gridTemplateColumns: 'calc(70vw - 20px) calc(30vw - 20px)',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    headerGridLandscape: {
        display: 'grid',
        gridTemplateColumns: 'calc(30vw - 10px) calc(70vw - 10px)',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    headerViewCheckButton: {
        textAlign: 'right',
    },
    instructionContainer: {
        textAlign: 'center',
        marginLeft: ElementDimensions.margin10 + 'px',
        marginRight: ElementDimensions.margin10 + 'px',
        paddingTop: ElementDimensions.padding20 + 'px ',
        paddingBottom: ElementDimensions.padding15 + 'px ',
    },
    instructionText: {
      marginBottom: ElementDimensions.margin10 + 'px',
    },
});

const MultipleChecks = () => {
    const isPortrait = true;
    let history = useHistory();
    const [checks, setChecks] = React.useState<CheckSummary[]>(history.location.state.checks);
    const [checkDetail, setCheckDetail] = React.useState<CheckFlat | null>(null);
    const [signalRInitialized, setSignalRInitialized] = React.useState<boolean>(false);
    const [signalRLoad, setSignalRLoad] = React.useState<boolean>(false);
    const [activeCheck, setActiveCheck] = React.useState<CheckSummary | undefined>(undefined);
    const [errorDialogOpen, setErrorDialogOpen] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>('');
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    React.useEffect(() => {

        setSignalRLoad(true);
                
        return () => {
        };
    }, [signalRLoad]);

    const CustomAccordion = styled((props: AccordionProps) => (
        <Accordion elevation={0} square {...props} />
      ))(() => ({
        marginBottom: ElementDimensions.margin10 + 'px',
        '&:not(:last-child)': {
          borderBottom: 0,
        },
        '&:before': {
          display: 'none',
        },
      }));

      const CustomAccordionSummary = styled((props: AccordionSummaryProps) => (
        <AccordionSummary
          {...props}
        />
      ))(() => ({
        backgroundColor: themePrimary.palette.grey[200],
        height: '100px',
        borderRadius: '6px',
        marginLeft: ElementDimensions.margin10 + 'px',
        marginRight: ElementDimensions.margin10 + 'px',
      }));
      
      const CustomAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
        padding: theme.spacing(2),
        borderLeft: '2px solid ' + themePrimary.palette.grey[200],
        borderRight: '2px solid ' + themePrimary.palette.grey[200],
        borderBottom: '2px solid ' + themePrimary.palette.grey[200],
        marginLeft: ElementDimensions.margin10 + 'px',
        marginRight: ElementDimensions.margin10 + 'px',
        marginTop: '-4px',
      }));
      

    const handlePayCheckButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        let check = checks.find(c => c.id.toString() === event.currentTarget.value);
        if (check !== null && check !== undefined) {
            history.push({
                pathname: '/checkout/check',
                state: { 
                    checkSummary: check,
                }
            });  
        }
    }

    const payCheckButtonProps: MiniButtonProps = {
        value:'',
        disabled: false,
        label: String_System_Pay.find(s => s.key === userState.state.locale)!!.value,
        onClickHandler: handlePayCheckButtonClick,
    }

    const handleViewCheckButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        let check = checks.find(c => c.id.toString() === event.currentTarget.value);
        if (check !== null && check !== undefined) {
            setActiveCheck(check)
        }
    }

    const viewCheckButtonProps: MiniButtonProps = {
        value:'',
        disabled: false,
        label: String_System_View.find(s => s.key === userState.state.locale)!!.value,
        onClickHandler: handleViewCheckButtonClick,
    }

    const signalRInitializedHandler = () => {
        setSignalRInitialized(true);
    }

    const signalRNotificationReceivedHandler = (type: CheckNotificationType,amount: number) => {
        if (type === CheckNotificationType.AmountClaimed) {

        }
        else if (type === CheckNotificationType.PaymentCompleted) {

        }
        else if (type === CheckNotificationType.CheckClosed) {
            
        }
        else if (type === CheckNotificationType.ClaimExpired) {
            
        }
    }

    const getCheck = async (cancelTokenSource: CancelTokenSource, check: CheckSummary) => {

        if (check !== undefined) {
            const request: GetCheckRequest = {
                user_id: userState.state.userId!!,
                use_claimed_amounts: true,
                release_claims: false,
            };        
    
            let url: string | undefined = process.env.REACT_APP_CHECKOUT_API_URL + "/location/" + checkOutState.state.restaurantId + "/checks/" + check.id

            const headers = {
                'X-API-Key': checkOutState.state.restaurantApiKey,
                'location_id': checkOutState.state.restaurantId
            }
    
            axios.post(url, request, { headers, cancelToken: cancelTokenSource.token })
            .then(function(response) {
                let r = response.data as GetCheckResponse;
    
                if (r.success === true) {
                    setCheckDetail(r.detail)
                }
                else {
                    setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogOpen(true);
                }
            })
            .catch(function(error) {
                if (error.response) {
                    setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                }
                else {
                    setErrorMessage(String_System_ConnectionError.find(s => s.key === userState.state.locale)!!.value);
                }
                
                setErrorDialogOpen(true);
            });
        }
    }

    const handleAccordionChange = (value: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        if (isExpanded) {
            var check = checks.find(c => c.id.toString() === value)

            if (check !== undefined) {
                setCheckDetail(null)
                getCheck(axios.CancelToken.source(), check)
            }
        }
        else {
            setActiveCheck(undefined)
        }
    }

    const handleErrorDialogClose = (event: React.MouseEvent<HTMLElement>) => {
        setErrorDialogOpen(false);
    }

    const errorDialogProps: ErrorDialogProps = {
        open: errorDialogOpen,
        message: errorMessage,
        tryAgain: false,
        onCloseHandler: handleErrorDialogClose,
    }

    return (
        <div>
            <div className={isPortrait === true ? classes.details : classes.detailsLandscape}>
                <div className={classes.instructionContainer}>
                    <Typography variant="h6" className={classes.instructionText}>
                        {String_MultipleChecks_Instruction(checks.length).find(s => s.key === userState.state.locale)!!.value}
                    </Typography>
                </div>
                {
                    checks.map((check, index) => {
                        return (
                            <CustomAccordion 
                                expanded={activeCheck !== undefined && activeCheck.id === check.id} 
                                onChange={handleAccordionChange(check.id.toString())}
                                disabled={false}>
                                <CustomAccordionSummary>
                                    <div key={'pairchecks-outer-container-' + check.number} className={classes.checkContainer}>
                                        <div className={classes.headerContainer} key={'pairchecks-header-outer-container-' + check.number}>
                                            <div className={isPortrait ? classes.headerGrid : classes.headerGridLandscape} key={'pairchecks-header-inner-container-' + check.number}>
                                                <Typography variant="h6" key={'pairchecks-header-check-number-' + check.number} className={classes.checkNumberLabel}>
                                                    {String_MultipleChecks_CheckTotalLabel.find(s => s.key === userState.state.locale)!!.value} {check.amount_due_string}
                                                </Typography>
                                                <div className={classes.headerViewCheckButton} key={'pairchecks-pay-check-button-container-' + check.number}>
                                                    <MiniButton
                                                        key={'pairchecks-pay-check-button-' + check.number}
                                                        value={check.id.toString()}
                                                        disabled={payCheckButtonProps.disabled}
                                                        label={payCheckButtonProps.label}
                                                        onClickHandler={payCheckButtonProps.onClickHandler} />
                                                </div>
                                                <Typography variant="body1" key={'pairchecks-header-check-number2-' + check.number} className={classes.checkNumberLabel}>
                                                    {checkOutState.state.posType !== POSType.Clear &&
                                                        String_MultipleChecks_CheckNumberLabel.find(s => s.key === userState.state.locale)!!.value
                                                    } 
                                                    {check.number}
                                                </Typography>
                                                <div className={classes.headerViewCheckButton} key={'pairchecks-view-check-button-container-' + check.number}>
                                                    {(activeCheck !== undefined && activeCheck.id === check.id) &&
                                                        <IconButton
                                                            className={classes.expanderButton}
                                                            size="medium"
                                                            value={check.id.toString()}
                                                            onClick={viewCheckButtonProps.onClickHandler}>
                                                            <ExpandLessIcon 
                                                                className={classes.expanderButton}/>
                                                        </IconButton>
                                                    }
                                                    {(activeCheck === undefined || activeCheck.id !== check.id) &&
                                                        <IconButton
                                                            className={classes.expanderButton}
                                                            size="medium"
                                                            value={check.id.toString()}
                                                            onClick={viewCheckButtonProps.onClickHandler}>
                                                            <ExpandMoreIcon 
                                                                className={classes.expanderButton}/>
                                                        </IconButton>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </CustomAccordionSummary>
                                <CustomAccordionDetails>
                                    {checkDetail !== null &&
                                        <CheckDetails details={checkDetail.details} isReceipt={false}/>
                                    }                                    
                                </CustomAccordionDetails>
                            </CustomAccordion>
                        );
                    })
                }
            </div>

            <ErrorDialog
                open={errorDialogProps.open}
                message={errorDialogProps.message}
                tryAgain={errorDialogProps.tryAgain}
                onCloseHandler={errorDialogProps.onCloseHandler} />

            {checkOutState.state.checks !== null && 
                <SignalR 
                    oldChecks={null}
                    messageType={CheckMessageType.Subscribe}
                    load={signalRLoad}
                    refreshCheck={false}
                    onNotificationReceived={signalRNotificationReceivedHandler}
                    onInitialized={signalRInitializedHandler} />
            }

        </div>
    );
};

export default MultipleChecks;